import { action } from 'easy-peasy';
import { IAuthActions, IAuthState } from 'types';

export const actions: IAuthActions = {
  setAuthorized: action<IAuthState, boolean>((state, payload) => {
    state.isAuthorized = payload;
  }),
};
